import projectType from "./projectType"
import projectAddress from './projectAddress'
import commercialProjectType from "./commercialProjectType"
import residentialProjectType from './residentialProjectType'
import fedStateProjectType from './fedStateProjectType'
import projectRole from "./projectRole"
import projectValue from './projectValue'
import projectFinancing from "./projectFinancing"
import projectFinancier from "./projectFinancier"
import projectPayingParty from "./projectPayingParty"
import projectContractValue from "./projectContractValue"
import projectMaterialCost from "./projectMaterialCost"
import projectTrade1 from "./projectTrade1"
import projectTrade2 from "./projectTrade2"
import projectName from "./projectName"

export default {
    title: 'Project Information',
    projectAddress,
    projectType,
    residentialProjectType,
    commercialProjectType, 
    fedStateProjectType,
    projectRole,
    projectValue,
    projectFinancing,
    projectFinancier,
    projectPayingParty,
    projectContractValue,
    projectMaterialCost,
    projectTrade1,
    projectTrade2,
    projectName
}